import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import api from '@/utils/api';
import { toast } from 'sonner';
import { Loader2, Save, Type } from 'lucide-react';

const MAX_LENGTH = 300;

export const GalleryCaptionCard = ({ initialCaption = '' }) => {
  const [caption, setCaption] = useState(initialCaption);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setCaption(initialCaption); }, [initialCaption]);

  const save = async () => {
    setSaving(true);
    try {
      const res = await api.put('/teacher/gallery/caption', { caption });
      setCaption(res.data.caption);
      toast.success('Gallery caption saved');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to save caption');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="mb-6" style={{ borderColor: '#E3E1DB' }} data-testid="gallery-caption-card">
      <CardHeader>
        <CardTitle style={{ fontFamily: 'Spectral, serif', color: '#163329' }}>
          <Type className="inline h-5 w-5 mr-2" />
          Gallery Caption
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm" style={{ color: '#5C635A' }}>
          A short note shown below your public gallery describing what you showcase. Leave empty to hide it.
        </p>
        <Textarea
          rows={2}
          maxLength={MAX_LENGTH}
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder="e.g. These are hairstyles a Learner will eventually learn and master them in future"
          data-testid="gallery-caption-input"
        />
        <div className="flex items-center justify-between">
          <span className="text-xs" style={{ color: '#9CA3AF' }}>{caption.length}/{MAX_LENGTH}</span>
          <Button onClick={save} disabled={saving} style={{ backgroundColor: '#163329' }} data-testid="save-gallery-caption-btn">
            {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />}
            Save Caption
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
